import { NoCostLoginMethod } from '@tob/shared/no-cost-authentication/constants';

/**
 * SPX Staff only supports quick-login for no-cost authentication activation.
 */
export function getNoCostAuthenticationActivationPromptSequence() {
  return [NoCostLoginMethod.Password, NoCostLoginMethod.QuickLogin];
}

// return milliseconds
export function getQuickLoginActivationCooldown() {
  return 0;
}

/**
 * @returns Maximum number of no cost authentication activation operations that we will prompt the user to do
 */
export function getMaximumActivationNum(): number | undefined {
  return 1;
}

export function getShouldTriggerNoCostAuthActivation(_: {
  isQuickLoginFeatureEnabled: boolean;
  isBiometricsLikelySupported: boolean;
  shouldAddToCPassword: boolean;
}): boolean {
  return false;
}

/**
 * SPX Staff delegates quick-login activation to the native client. Trigger
 * activation only when the quick-login feature is enabled, the user opted in on
 * the login entrance page, and quick login is not already enabled for this user.
 */
export function getNeedActivation({
  isQuickLoginFeatureEnabled,
  doesUserIntendToActivateQuickLogin,
  isQuickLoginEnabled = false,
  shouldAddToCPassword = false,
}: {
  isQuickLoginFeatureEnabled: boolean;
  doesUserIntendToActivateQuickLogin: boolean;
  isQuickLoginEnabled?: boolean;
  shouldAddToCPassword?: boolean;
}): boolean {
  return (
    (isQuickLoginFeatureEnabled &&
      doesUserIntendToActivateQuickLogin &&
      !isQuickLoginEnabled) ||
    shouldAddToCPassword
  );
}
